import "./popver.less";
import { isOurApp, isDingTalk, isUC, isWeChat, isBaidu } from '../util/useragent';

import OverscrollBehavior from "../util/behavior";

const CLSS = "call-all-app-mask";
const ID = "call-all-app-popver";


let defaultConfig = {
    close: function () { },
    success: function () { },
    goWebLogin: function () { },
    imgUrl: "//gw.alicdn.com/tfs/TB1iiO7ESBYBeNjy0FeXXbnmFXa-654-800.png",
    manualImageUrl: "//gw.alicdn.com/tfs/TB1iiO7ESBYBeNjy0FeXXbnmFXa-654-800.png",
    popverImageWidth: "88vw",
    popverImageText: "需要登录查看更多内容使用支付宝快捷登录",
    "popverImageTextWidth": "38vw"
}

const ob = new OverscrollBehavior({
    // 锁区
    lockAreas: ['.call-all-app-mask', '.cont'],
    // overscroll 行为
    overscrollBehaviors: [
    ]
});

const Popver = {
    init: function (config = {}) {
        Object.keys(config).forEach(function (key) {
            defaultConfig[key] = config[key];
        })
        this.config = defaultConfig;
        this.isManual = !!this.config.manual;

        // 集团内部app排除钉钉、UC
        if ((isOurApp && !isDingTalk && !isUC) || isWeChat || isBaidu) {
            return;
        }
        this.mask();
        this.showDialog();
        this.bindEvent();
        this.disabled_scroll();
    },
    wheel: function (e) {

        function preventDefault(e) {
            e = e || window.event;
            if (e.preventDefault)
                e.preventDefault();
            e.returnValue = false;
        }
        preventDefault(e);
    },
    disabled_scroll: function () {
        if (window.addEventListener) {
            window.addEventListener('DOMMouseScroll', this.wheel, false);
        }
        window.onmousewheel = document.onmousewheel = this.wheel;
    },
    mask: function () {
        var _mask = document.createElement('div');
        _mask.className = CLSS;
        var body = document.getElementsByTagName("body")[0];
        this._mask = _mask;
        body.appendChild(_mask);
    },
    showDialog: function () {
        //弹出对话框
        let popver_content = document.createElement('div');
        popver_content.id = ID;
        let body = document.getElementsByTagName("body")[0];
        let imgUrl = this.isManual ? this.config.manualImageUrl : this.config.imgUrl;
        let imgWidth = this.isManual ? this.config.manualImageWidth : this.config.popverImageWidth;
        let textWidth = this.isManual ? this.config.manualImageTextWidth : this.config.popverImageTextWidth;
        let text =  this.isManual ?  this.config.manualImageText : this.config.popverImageText;

        let iconImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAAD1BMVEX///////9HcEz////////5TfPbAAAABHRSTlOsAwDFXWZIQQAAAF5JREFUGNNdj8sNwCAMQx8qA9BuECboCBy6/0wtDhJWuRD5l5j76vkCallzG7SRRNRCLOLD6ElMiJ7ERMhPAElLiPhTOuRDfpT3KPc/u8a8nmm7/Aa7zW/2Lt5xdz9eCUMbODU/xEsAAAAASUVORK5CYII=';
        popver_content.innerHTML = "<div class='cont' style='width:" + imgWidth + "'><a href='javascript:' class='call-app-sure'><img src='" + imgUrl + "' /><p class='call-app-img-text' style='width:" + textWidth + "'>" + text + "</p></a>" +
            "</div>" +
            "<div class='call-app-colse'><img src=" + iconImg + " /></div>";
            
        this.dialog = popver_content;
        body.appendChild(popver_content);

        if (window['goldlog'] && goldlog.record) {
            let dpid = goldlog.pvid;
            if (this.isManual) {
                goldlog.record('/1688seo.tinyapp.detailpurchase', 'EXP', 'dpid=' + dpid, 'GET')
            } else {
                goldlog.record('/1688seo.tinyapp.canbecall', 'EXP', 'dpid=' + dpid, 'GET')
            }
        }
        ob.start();
    },
    enable_scroll: function () {
        if (window.removeEventListener) {
            window.removeEventListener('DOMMouseScroll', this.wheel, false);
        }
        window.onmousewheel = document.onmousewheel = document.onkeydown = null;
    },
    close: function () {
        this._removeMask();
        this._removeDialog();
        this.enable_scroll();
        ob.stop();
    },
    _removeMask: function () {
        this._mask.parentNode.removeChild(this._mask);
    },
    _removeDialog: function () {
        this.dialog.parentNode.removeChild(this.dialog);
    },
    bindEvent: function () {
        var self = this;
        if (document.getElementsByClassName("call-app-colse").length > 0) {
            document.getElementsByClassName("call-app-colse")[0].onclick = function () {
                self.config.goWebLogin && self.config.goWebLogin();
                self.close && self.close();
                self.config.close && self.config.close();
            }
        }

        if (document.getElementsByClassName("call-app-cancel").length > 0) {
            document.getElementsByClassName("call-app-cancel")[0].onclick = function () {
                self.close && self.close();
                self.config.close && self.config.close();
            }
        }

        if (document.getElementsByClassName("call-app-cancel2").length > 0) {
            document.getElementsByClassName("call-app-cancel2")[0].onclick = function () {
                self.close && self.close();
                self.config.goWebLogin && self.config.goWebLogin();
            }
        }

        if (document.getElementsByClassName("call-app-sure").length > 0) {
            document.getElementsByClassName("call-app-sure")[0].onclick = function () {
                //点击确定唤起支付宝
                // debugger;
                self.config.success && self.config.success();
            }
        }

    }
}

export default Popver;


// WEBPACK FOOTER //
// ./src/popver/index.js